import React from "react";

const CompanyListSkeleton = ({ count = 6 }) => {
  const skeletonItems = Array.from({ length: count });

  return (
    <div className="company-list-skeleton">
      {skeletonItems.map((_, index) => (
        <div
          key={index}
          className="skeleton-item mb-4 p-3 rounded"
          style={{
            backgroundColor: "#f3f3f3",
            boxShadow: "0 0 4px rgba(0,0,0,0.1)",
          }}
        >
          {/* Company name */}
          <div
            className="skeleton-line"
            style={{
              width: "60%",
              height: "20px",
              backgroundColor: "#e0e0e0",
              borderRadius: "4px",
              marginBottom: "10px",
            }}
          ></div>

          {/* Tags */}
          <div
            className="skeleton-line"
            style={{
              width: "80%",
              height: "16px",
              backgroundColor: "#e0e0e0",
              borderRadius: "4px",
              marginBottom: "8px",
            }}
          ></div>

          {/* Description */}
          <div
            className="skeleton-line"
            style={{
              width: "100%",
              height: "14px",
              backgroundColor: "#e0e0e0",
              borderRadius: "4px",
              marginBottom: "6px",
            }}
          ></div>
          <div
            className="skeleton-line"
            style={{
              width: "90%",
              height: "14px",
              backgroundColor: "#e0e0e0",
              borderRadius: "4px",
            }}
          ></div>
        </div>
      ))}
    </div>
  );
};

export default CompanyListSkeleton;
